"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @since 0.0.2
 */
var fc = require("fast-check");
var Option_1 = require("fp-ts/lib/Option");
/**
 * Returns an `Arbitrary` that yelds only `some`s
 *
 * @since 0.0.2
 */
function getSome(arb) {
    return arb.map(Option_1.some);
}
exports.getSome = getSome;
/**
 * Returns an `Arbitrary` that yelds only `none`s
 *
 * @since 0.0.2
 */
function getNone() {
    return fc.constant(Option_1.none);
}
exports.getNone = getNone;
/**
 * Returns an `Arbitrary` that yelds both `none`s and `some`s
 *
 * @since 0.0.2
 */
function getOption(arb) {
    return fc.oneof(getNone(), getSome(arb));
}
exports.getOption = getOption;
